import { Box, Button, Flex, useMediaQuery } from "@chakra-ui/react";
import { Modal } from "@reconvert/react-ui-component";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectAppState, toggleHelpModal } from "../../app/slice/appSlice";
import { useDirection } from "../../hooks/useDirection";
import ReviewCollectorModalV2 from "../ReviewCollector/ReviewCollectorModalV2";
import { BookDemoBanner } from "../BookDemoBanner";
import { APP_PLATFORM, BOOK_DEMO_BANNER_MAX_CAP, UNLEASH_SHOW_BOOK_DEMO_BANNER_FORCEFULLY } from "../../config";
import { Platform } from "../../models";
import { updateShopInfoThunk, updateShopInfoLocal } from "../../app/slice/shopinfoSlice";
import { selectShopInfoState } from "../../ReviewProviderWrapper";
import styles from './HelpModel.module.css';
import { useFlag } from "@unleash/proxy-client-react";

const HelpModal = () => {
  const { t } = useTranslation();
  const { showHelpModal, helpArticleLink, helpArticleTitle, subscriptionDetails, isBookDemoBannerVisible } = useAppSelector(selectAppState);
  const dispatch = useAppDispatch();
  const { isRTL } = useDirection();
  const { shopInfo } = useAppSelector(selectShopInfoState);
  const isMobileView = useMediaQuery('(max-width: 768px)')[0];
  const isShowBookDemoBannerForcefully = useFlag(UNLEASH_SHOW_BOOK_DEMO_BANNER_FORCEFULLY);

  if (!showHelpModal) return null;

  const onHelpModalClose = () => {
    dispatch(toggleHelpModal());
    dispatch(updateShopInfoLocal({
      show_help_video_modal: "1",
    }));
    dispatch(updateShopInfoThunk({
      show_help_video_modal: "1",
    }));
  };

  return (
    <Modal
      isOpen={showHelpModal}
      onClose={onHelpModalClose}
      closeOnEsc={true}
      title={helpArticleTitle ?? null}
      hideCloseButton={true}
      size="6xl"
      styles={
        {
          content: {
            height: "calc(100vh - 128px)",
          },
        }
      }
      footer={
        <Flex
          margin={isMobileView ? '0 5px' : '0 16px'}
          justifyContent="space-between"
          alignItems="center"
          width={isMobileView ? '100vw' : 'calc(100% - 64px)'}
          minHeight="80px"
          position={isMobileView ? 'relative' : undefined}
        >
          <Box />
          <Box
            className={
              isMobileView
                ? styles.reviewCollectorModalV2Mobile
                : styles.reviewCollectorModalV2Desktop
            }>
            {APP_PLATFORM === Platform.Shopify && <ReviewCollectorModalV2 />}
          </Box>
          <Box
            className={
              isMobileView
                ? styles.closeButtonMobile
                : styles.closeButtonDesktop
            }>
            <Button
              padding={'8px 16px'}
              variant={'secondary'}
              onClick={onHelpModalClose}
              style={{ ...(isRTL && { marginLeft: "16px" }) }}
            >
              {t('Close')}
            </Button>
          </Box>
        </Flex>
      }
    >
      {APP_PLATFORM === Platform.Shopify && <BookDemoBanner location="help_popup" marginBottom="24px" />}
      <iframe src={helpArticleLink} title={helpArticleTitle} style={{ width: "100%", height: (APP_PLATFORM === Platform.Shopify && isBookDemoBannerVisible && ((subscriptionDetails?.maxCap || 0) > Number(BOOK_DEMO_BANNER_MAX_CAP) || isShowBookDemoBannerForcefully) && shopInfo?.[`hide_book_demo_banner_help_popup`] !== 1) ? "calc(100% - 150px)" : "100%"  }} />
    </Modal>
  );
};

export default HelpModal;
